<div class="page-loader d-flex align-items-center justify-content-center">
    <app-loading *ngIf="isLoaderVisible" class="d-inline-block"></app-loading>
</div>
